<input
  id="datepicker"
  type="text"
  name="datepicker"
  placeholder="Date"
  autocomplete="off"
  class="date-input"
  [placeholder]="placeholder"
  [value]="displayValue"
  readonly="readonly"
/>
